<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page :page-content="false">
                <!-- header -->
                <cm-navbar :title="$ml.get('inventory')">
                    <f7-nav-right>
                        <input class="search-input" placeholder="Tìm..." v-model="filterInput" />
                        <f7-link @click="search"><i class="f7-icons">search</i></f7-link>
                        <f7-link @click="refresh"><i class="f7-icons">refresh</i></f7-link>
                    </f7-nav-right>
                </cm-navbar>
                <!-- END header -->
                <!-- body -->
                <f7-toolbar tabbar bottom>
                    <f7-link tab-link="#tab-1" tab-link-active>{{ $ml.get('containers') }}</f7-link>
                    <f7-link tab-link="#tab-2">{{ $ml.get('covers') }}</f7-link>
                </f7-toolbar>

                <f7-tabs animated>
                    <!-- containers -->
                    <f7-tab id="tab-1" class="page-content" tab-active>
                        <f7-swiper :params="{ observer: true }"  v-if="!showSearch">
                            <f7-swiper-slide v-for="(type, index1) in containerType" :key="index1">
                                <f7-block-title>{{ type.name }}</f7-block-title>
                                <div v-if="! type.containers.length">
                                    <f7-card :content="$ml.get('noRecords')"></f7-card>
                                </div>
                                <div class="list media-list" v-if="type.containers.length">
                                    <ul>
                                        <li class="media-item" v-for="(container, index2) in type.containers" :key="index2">
                                            <div class="item-content">
                                                <div class="item-inner">
                                                    <div class="item-title-row">
                                                        <div class="item-title" @click="changeCapacity(container.id, container.capacity)">
                                                            <f7-link v-show="container.capacity > 0">{{ container.name }}</f7-link>
                                                            <span v-show="container.capacity <= 0">{{ container.name }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="item-subtitle">
                                                        <f7-progressbar v-bind:style="{'--f7-theme-color': container.material ? container.material.materialtype.color : 'blue'}" :progress="percent(container)"></f7-progressbar>
                                                    </div>
                                                    <div class="item-text" v-if="container.material">
                                                        {{ container.material.name }} ({{ $helper.numFormat(container.capacity) }}) <span v-if="container.solo">| {{ container.solo }}</span> <br>
                                                        <span v-if="container.origin">{{ $ml.get('lo') }}: {{ container.note ? '(' + container.note + ')' : '' }} {{ container.last_updated }} {{ container.origin }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </f7-swiper-slide>
                        </f7-swiper>
                        <div v-else>
                            <f7-block-title><b>Tổng: {{ $helper.numFormat(filteredTotal) }}</b></f7-block-title>
                            <div v-for="(type, index1) in filteredContainerType" :key="index1">
                                <f7-block-title><b>{{ type.name }} ({{ $helper.numFormat(type.total || 0) }})</b></f7-block-title>
                                <div v-if="! type.containers.length">
                                    <f7-card :content="$ml.get('noRecords')"></f7-card>
                                </div>
                                <div class="list media-list" v-if="type.containers.length">
                                    <ul>
                                        <li class="media-item" v-for="(container, index2) in type.containers" :key="index2">
                                            <div class="item-content">
                                                <div class="item-inner">
                                                    <div class="item-title-row">
                                                        <div class="item-title" @click="changeCapacity(container.id, container.capacity)">
                                                            <f7-link v-show="container.capacity > 0">{{ container.name }}</f7-link>
                                                            <span v-show="container.capacity <= 0">{{ container.name }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="item-subtitle">
                                                        <f7-progressbar v-bind:style="{'--f7-theme-color': container.material ? container.material.materialtype.color : 'blue'}" :progress="percent(container)"></f7-progressbar>
                                                    </div>
                                                    <div class="item-text" v-if="container.material">
                                                        {{ container.material.name }} ({{ $helper.numFormat(container.capacity) }}) <span v-if="container.solo">| {{ container.solo }}</span> <br>
                                                        <span v-if="container.origin">{{ $ml.get('lo') }}: {{ container.note ? '(' + container.note + ')' : '' }} {{ container.last_updated }} {{ container.origin }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </f7-tab>

                    <!-- covers -->
                    <f7-tab id="tab-2" class="page-content">
                        <f7-swiper :params="{ observer: true }">
                            <f7-swiper-slide key="0">
                                <div v-if="! covers.length">
                                    <f7-card :content="$ml.get('noRecords')"></f7-card>
                                </div>
                                <div class="list media-list" v-if="covers.length">
                                    <ul>
                                        <li class="media-item" v-for="(cover, index2) in covers" :key="index2">
                                            <div class="item-content">
                                                <div class="item-inner">
                                                    <div class="item-title-row">
                                                        <div class="item-title">{{ cover.name }}</div>
                                                    </div>
                                                    <div class="item-text">
                                                        {{ $ml.get('style') }}: {{ cover.packing ? cover.packing.value : '' }} Kg <br>
                                                        {{ $ml.get('amount') }}: {{ $helper.numFormat(cover.remaining_amount) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </f7-swiper-slide>
                        </f7-swiper>
                    </f7-tab>
                </f7-tabs>
                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'

    export default {
        name: 'Container',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                containerType: [],
                filteredContainerType: [],
                covers:   [],
                showSearch: false,
                filterInput: "",
                filteredTotal: 0,
            }
        },
        methods: {
            percent(container) {
                return (container.capacity / container.max_capacity) * 100
            },

            async changeCapacity(id, capacity) {
                if (capacity <= 0) return false
                if (! this.$helper.hasPermission('change_capacity')) return false

                this.$f7.dialog.prompt(
                    this.$ml.get('capacity'),
                    this.$ml.get('fillCurrentAmount'),
                    async (value) => {
                        this.$f7.dialog.preloader(this.$ml.get('processing'))
                        let result = await Mutation.changeCapacity(id, value).execute()

                        if (result.data.errors) {
                            this.$f7.dialog.close()
                            let message = this.$helper.errors(result.data.errors)
                            return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                        }

                        let data = await Query.withContainersByType().get()
                        this.containerType = this.$helper.data(data, 'container_by_type')
                        this.$f7.dialog.close()

                        return this.$f7.dialog.alert(this.$ml.get('success.changeCapacity'), this.$ml.get('information'))
                    },
                )
            },

            async search() {
                let filterInput = this.filterInput;
                if (!filterInput) {
                    this.showSearch = false;
                    return;
                }
                this.$f7 && this.$f7.dialog.preloader(this.$ml.get('processing'))
                let filteredTotal = 0;
                let data = this.containerType;
                
                // Kiểm tra nếu có dấu "" thì tìm chính xác, không thì dùng includes
                let searchTerm = filterInput.trim();
                let isExactSearch = false;
                
                if (searchTerm.startsWith('"') && searchTerm.endsWith('"') && searchTerm.length > 1) {
                    // Bỏ dấu "" và chuyển sang exact search
                    searchTerm = searchTerm.slice(1, -1);
                    isExactSearch = true;
                }
                
                const searchTermLower = searchTerm.toLowerCase();
                
                const filteredResult = data
                .map(function (item) {
                    // Lọc theo exact match hoặc includes
                    const filteredContainers = item.containers.filter(function (container) {
                        if (!container.material || !container.material.name) return false;
                        
                        const materialName = container.material.name.toLowerCase();
                        return isExactSearch 
                            ? materialName === searchTermLower
                            : materialName.includes(searchTermLower);
                    });

                    // Tính tổng capacity của các container đã lọc
                    const totalCapacity = filteredContainers.reduce(function (sum, container) {
                        return sum + (container.capacity || 0);
                    }, 0);

                    if (totalCapacity > 0) {
                        filteredTotal += totalCapacity;
                    }

                    // Nếu còn containers sau khi lọc, trả về item với containers đã lọc và tổng capacity
                    if (filteredContainers.length > 0) {
                        return { 
                            ...item, 
                            containers: filteredContainers,
                            total: totalCapacity // Gán tổng capacity vào item
                        };
                    }
                    return null;
                })
                .filter(item => item !== null);
                this.showSearch = true;
                this.filteredContainerType = filteredResult;
                this.filteredTotal = filteredTotal;
                this.$f7 && this.$f7.dialog.close()
            },

            async refresh() {
                this.filterInput = "";
                this.filteredTotal = 0;
                this.showSearch = false;
                this.$f7 && this.$f7.dialog.preloader(this.$ml.get('processing'))
                let data = await Query.withContainersByType().get()
                this.containerType = this.$helper.data(data, 'container_by_type')
                this.$f7 && this.$f7.dialog.close()

                let covers = await Query.withCovers(null, null, null).get()
                this.covers = this.$helper.data(covers, 'covers')
            },
        },

        async created() {
            await this.refresh()
        },
    }
</script>

<style scoped>
.progressbar {
    height: 18px;
}
.search-input {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    min-width: 150px;
    height: 100%;
    display: block;
    border: var(--f7-searchbar-input-border-width) solid var(--f7-searchbar-input-border-color);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-family: inherit;
    font-weight: 400;
    color: var(--f7-searchbar-input-text-color);
    font-size: 16px;
    padding: 8px;
    background-color: var(--f7-searchbar-input-bg-color);
    border-radius: var(--f7-searchbar-input-border-radius);
    position: relative;
    margin-right: 10px;
    margin-left: 10px;
}
</style>